import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: ['!font-normal', 'text-body-sm'],
});

export default ArticleDisclosureLabel;
